import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { ClientService } from '@app/core/services/client.service';
import { NotificationService } from '@app/core/services/notification.service';
import { KYC_STATE_STYLE_MAP, KycStateEditDialogData, KycStates, STATE_OPTIONS } from '@app/core/types/kyc-state';

@Component({
  selector: 'itfg-kyc-state-edit-dialog',
  templateUrl: './kyc-state-edit-dialog.component.html',
  styleUrl: './kyc-state-edit-dialog.component.scss',
  standalone: false,
})
export class KycStateEditDialogComponent implements OnInit, OnDestroy {
  public STATE: typeof KycStates = KycStates;
  public STYLE_MAP = KYC_STATE_STYLE_MAP;
  public STATE_OPTIONS = STATE_OPTIONS;

  public form: UntypedFormGroup;
  public isLoading: boolean = false;

  public unsubscribe = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: KycStateEditDialogData,
    public dialogRef: MatDialogRef<KycStateEditDialogComponent, boolean>,
    public fb: FormBuilder,
    public clientService: ClientService,
    public notificationService: NotificationService,
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      state: [this.data.currentState],
    });
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  onSubmit(): void {
    const newKycState = this.form.value.state as KycStates;
    this.isLoading = true;

    // TODO: To be used in the future? For now allow operators to only invalidate or validate the kyc state.
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}